import React from 'react'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { LGYAddress } from 'app/components/util/lgy-field/LgyField'
import { formatDollars } from '../common/AssignmentUtils'

const BorrowerSection = ({ assignmentDetails }) =>
  <LgySubsection header='Veteran/Co-Borrower Information' className='assignment-details-child'>
    <table>
      <caption className='usa-sr-only'>Veteran/Co-Borrower Information</caption>
      <tbody>
        <tr>
          <th scope='row'>Veteran/Co-Borrower Name:</th>
          <td>{assignmentDetails.purchaserFirstName} {assignmentDetails.purchaserLastName}</td>
        </tr>
        <tr>
          <th scope='row'>Address:</th>
          <td>
            <LGYAddress
              streetAddress1={assignmentDetails.purchaserAddressOne}
              streetAddress2={assignmentDetails.purchaserAddressTwo}
              city={assignmentDetails.purchaserCityName}
              state={assignmentDetails.purchaserStateCode}
              zip={assignmentDetails.purchaserZipPrefixNumber}
              zipSuffix={assignmentDetails.purchaserZipFirstSuffix} />
          </td>
        </tr>
        <tr>
          <th scope='row'>Veteran Phone Number:</th>
          <td>{assignmentDetails.purchaserPhoneNumber}</td>
        </tr>
        <tr>
          <th scope='row'>Veteran Email Address:</th>
          <td>{assignmentDetails.purchaserEmailAddress}</td>
        </tr>
        {assignmentDetails.salePrice && <tr>
          <th scope='row'>Purchase price of property:</th>
          <td>${formatDollars(assignmentDetails.salePrice)}</td>
        </tr>}
        {assignmentDetails.refinanceAmount && <tr>
          <th scope='row'>Refinancing amount of proposed loan:</th>
          <td>${formatDollars(assignmentDetails.refinanceAmount)}</td>
        </tr>}
        <tr>
          <th scope='row'>Is the buyer purchasing the lot separately?</th>
          <td>{assignmentDetails.purchaseLotIndicator === '1' ? 'Yes' : 'No'}</td>
        </tr>
      </tbody>
    </table>
  </LgySubsection>

export default BorrowerSection
